import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const BigContext = /*#__PURE__*/createContext(undefined);
export const BigContextProvider = ({
  abstractTextElementStyleOverrides,
  children
}) => {
  const value = useMemo(() => ({
    abstractTextElementStyleOverrides
  }), [abstractTextElementStyleOverrides]);
  return /*#__PURE__*/_jsx(BigContext.Provider, {
    value: value,
    children: children
  });
};

/**
 * Provides the context for the `Big` component.
 * Note: The context is only available when the `Big` component is rendered as an ancestor.
 * @returns BigContext - The context for the `Big` component.
 * @returns BigContext.abstractTextElementStyleOverrides - Style overrides to be applied to the `AbstractTextElement` component.
 */
export const useBigContext = () => {
  const bigContext = useContext(BigContext);
  return bigContext;
};